module.exports = __webpack_public_path__ + "img/img04.e32915d8.png";